import React, {useState, useEffect, useRef} from 'react';
import {useParams} from 'react-router-dom';
import {orgId, defaultErrorHandler} from '../../../context/context';
import customFormsV2Client from '../../../infrastructure/acerill/custom-forms-v2-client';
import shopifyV1Client from '../../../infrastructure/acerill/shopify-v1-client';
import CenteredSpinner from '../../../libs/react-components-admin/spinners/centered-spinner';
import FormSelector from '../../forms/form-selector';
import SaveCancelBar from '../../../libs/react-components-admin/buttons/save-cancel-bar';
import {TextField} from '../../../libs/react-components-admin/fields/text-like-field';
import Section from '../../../libs/react-components-admin/section/section';
import Support from './support';

const IntegrationScaffold = ({title, type, bodyFn}) => {

  const {integrationId} = useParams();

  const formIdAndPromiseRef = useRef();

  const [model, setModel] = useState();
  const [form, setForm] = useState();

  useEffect(() => {
    if (!model || !model.formId ||
      model.formId === (formIdAndPromiseRef.current || {}).formId ||
      (!formIdAndPromiseRef.current && (form || {}).id === model.formId)) {
      return;
    }
    setForm(null);
    formIdAndPromiseRef.current = {
      formId: model.formId,
      formPromise: customFormsV2Client
        .findFormById(model.formId)
        .then(f => {
          if ((formIdAndPromiseRef.current || {}).formId === f.id) {
            setForm(f);
            formIdAndPromiseRef.current = null;
          }
        })
        .catch(defaultErrorHandler),
    };
  }, [model]);

  useEffect(() => {
    loadIntegration().catch(defaultErrorHandler);
  }, []);

  const loadIntegration = () => {
    setModel(null);
    return customFormsV2Client
      .findShopifyIntegrationById(integrationId)
      .then(integration => integration || shopifyV1Client.findShopById(orgId)
        .then(shop => ({id: integrationId, type: type, support: {emailAddresses: [shop.email]}}))
      )
      .then(integration => setModel(integration));
  };

  const isModelValid = () => {
    return model.id && model.formId && model.mappings &&
      Object.values(model.mappings).some(m => !!m) &&
      ((model.support || {}).emailAddresses || []).length > 0;
  };

  const save = () => customFormsV2Client.saveShopifyIntegration(model);

  return <Section title={title} noMargin={true}>
    {!model ?
      <CenteredSpinner/> :
      <div className="row justify-content-center">
        <div className="col-12 col-md-8">
          <TextField id="name"
                     label="Name"
                     helpBlock={<>Helps you identify this integration</>}
                     value={model.name}
                     onChange={v => setModel({...model, name: v})}/>
          <FormSelector allowNull={false}
                        hideWhenNoChoice={false}
                        initialValue={model.formId}
                        onChange={v => setModel({...model, formId: v})}/>
          {!form ?
            <CenteredSpinner/> :
            bodyFn(form, model, (k, v) => setModel(m => {
              const updatedModel = {...m};
              updatedModel[k] = v;
              return updatedModel;
            }))
          }
          <Support model={model.support}
                   onChange={v => setModel({...model, support: v})}/>
          <div className="w-100 my-5"/>
          <SaveCancelBar saveAction={() => save()}
                         cancelAction={() => loadIntegration()}
                         saveDisabled={!isModelValid()}
                         errorHandler={defaultErrorHandler}/>
        </div>
      </div>
    }
  </Section>;
};

export default IntegrationScaffold;
